"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var formik_1 = require("formik");

var react_1 = __importDefault(require("react"));

var FormikConnected =
/** @class */
function (_super) {
  __extends(FormikConnected, _super);

  function FormikConnected() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FormikConnected.prototype.componentDidUpdate = function (prevProps) {
    var prevEmailValidation = prevProps.emailValidation,
        prevPhoneValidation = prevProps.phoneValidation,
        prevUserNameValidation = prevProps.userNameValidation;
    var _a = this.props,
        onEmailValidated = _a.onEmailValidated,
        onPhoneValidated = _a.onPhoneValidated,
        nextEmailValidation = _a.emailValidation,
        nextPhoneValidation = _a.phoneValidation,
        onUserNameValidated = _a.onUserNameValidated,
        nextUserNameValidation = _a.userNameValidation,
        formik = _a.formik;

    if (onEmailValidated) {
      onEmailValidated(prevEmailValidation, nextEmailValidation, formik);
    }

    if (onPhoneValidated) {
      onPhoneValidated(prevPhoneValidation, nextPhoneValidation, formik);
    }

    if (onUserNameValidated) {
      onUserNameValidated(prevUserNameValidation, nextUserNameValidation, formik);
    }
  };

  FormikConnected.prototype.render = function () {
    return null;
  };

  return FormikConnected;
}(react_1.default.Component);

exports.default = formik_1.connect(FormikConnected);